import type { FC } from 'react';
import { useState } from 'react';
import { Button, Group, TextInput } from '@mantine/core';
import type { RenamePrefixFormProps } from './RenamePrefixForm.types';

const RenamePrefixForm: FC<RenamePrefixFormProps> = ({
    initialPrefix,
    isPending,
    onSubmit,
    onCancel
}) => {
    const [value, setValue] = useState(initialPrefix);
    const trimmed = value.trim();
    const isUnchanged = trimmed === initialPrefix;
    const isInvalid = trimmed.length === 0;

    return (
        <form
            className="flex flex-col gap-3"
            onSubmit={(event) => {
                event.preventDefault();
                if (isInvalid || isUnchanged) {
                    return;
                }
                onSubmit(trimmed);
            }}
        >
            <TextInput
                autoFocus
                data-autofocus
                label="Version prefix"
                placeholder="Enter version prefix"
                value={value}
                onChange={(event) => {
                    setValue(event.currentTarget.value);
                }}
            />
            <Group gap="sm" justify="flex-end">
                <Button variant="default" onClick={onCancel}>
                    Cancel
                </Button>
                <Button
                    disabled={isInvalid || isUnchanged}
                    loading={isPending}
                    type="submit"
                >
                    Save
                </Button>
            </Group>
        </form>
    );
};

export default RenamePrefixForm;
